
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.516 17.516a7.763 7.763 0 01-2.15 1.523c.578-.77 1.062-1.737 1.41-2.84h1.8a7.81 7.81 0 01-1.06 1.317zm-12.09-1.317h1.797c.349 1.103.831 2.07 1.412 2.84a7.723 7.723 0 01-2.15-1.523 7.735 7.735 0 01-1.06-1.317zm1.058-9.715a7.797 7.797 0 012.15-1.524c-.578.772-1.062 1.738-1.41 2.84H5.425a7.78 7.78 0 011.058-1.316zM18.575 7.8h-1.798c-.349-1.1-.831-2.067-1.412-2.839.798.382 1.52.893 2.15 1.524.403.404.757.843 1.06 1.315zm-1.186 3.6a14.404 14.404 0 00-.297-2.4h2.11c.322.766.513 1.57.575 2.4H17.39zM12.6 15v-2.4h3.587a12.81 12.81 0 01-.324 2.4H12.6zm2.19 2.747c-.403.673-.88 1.214-1.38 1.565a2.717 2.717 0 01-.808.4V16.2h2.91a8.706 8.706 0 01-.722 1.548zM11.4 16.2v3.514a2.701 2.701 0 01-.81-.401c-.498-.352-.975-.894-1.38-1.565a8.61 8.61 0 01-.72-1.548h2.91zm-3.587-3.6H11.4V15H8.137a12.81 12.81 0 01-.324-2.4zM4.797 15a7.744 7.744 0 01-.574-2.4H6.61c.035.837.135 1.642.297 2.4h-2.11zM11.4 9v2.4H7.813A12.81 12.81 0 018.137 9H11.4zM9.21 6.253c.405-.674.882-1.214 1.38-1.565.267-.187.537-.322.81-.4v3.511H8.489c.2-.563.442-1.08.72-1.546h.002zm3.39 1.546V4.287c.273.079.545.214.81.401.498.352.975.892 1.38 1.565.279.466.52.983.72 1.546h-2.911.001zM15.863 9c.18.768.29 1.571.324 2.4H12.6V9h3.263zM6.908 9a14.261 14.261 0 00-.297 2.4H4.223c.062-.83.256-1.634.574-2.4h2.11zm10.184 6c.162-.758.264-1.563.297-2.4h2.388a7.706 7.706 0 01-.574 2.4h-2.11zM12.001 3a9 9 0 100 18 9 9 0 000-18z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    